export class BffError extends Error {
  constructor(
    readonly displayMessage: string,
    readonly message: string,
  ) {
    super(message);
  }
}
